(()=>{
  const init=()=>{
    const button=document.getElementById('ew-back-to-top');
    if(!button||button.dataset.ready)return;
    button.dataset.ready='true';
    let queued=false;
    let observedRoot;
    let observedCart;
    let observedCollagen;
    const mobile=window.matchMedia('(max-width:750px)');
    const setProperty=(element,name,value)=>{if(element.style.getPropertyValue(name)!==value)element.style.setProperty(name,value)};
    const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(update)}};
    const resize=new ResizeObserver(schedule);
    const update=()=>{
      queued=false;
      const hidden=window.scrollY<Math.max(500,window.innerHeight*.75);
      if(button.hidden!==hidden)button.hidden=hidden;
      const collagen=document.querySelector('.ew-approved');
      if(collagen&&collagen!==observedCollagen){new MutationObserver(schedule).observe(collagen,{attributes:true,attributeFilter:['class']});observedCollagen=collagen}
      const cart=collagen?.querySelector('.sticky')||document.getElementById('ew-sticky-cart');
      if(cart&&cart!==observedCart){resize.observe(cart);observedCart=cart}
      const cartVisible=cart&&!cart.hidden&&getComputedStyle(cart).display!=='none';
      const lift=cartVisible?Math.max(0,innerHeight-cart.getBoundingClientRect().top):0;
      const preview=document.getElementById('PBarNextFrame')?64:0;
      const offset=Math.max(lift,preview);
      setProperty(button,'--ew-widget-lift',offset+'px');
      const host=document.getElementById('ads-agent-host');
      const root=host?.shadowRoot;
      if(host)setProperty(host,'--ew-widget-lift',offset+'px');
      if(root&&!root.getElementById('ew-mobile-launcher-layout')){
        const style=document.createElement('style');
        style.id='ew-mobile-launcher-layout';
        style.textContent='@media(max-width:750px){[data-testid="entrypoint"]{left:12px!important;right:auto!important;bottom:calc(12px + env(safe-area-inset-bottom,0px) + var(--ew-widget-lift,0px))!important;margin:0!important;transform:none!important}[data-testid="entrypoint"] .size-16{width:40px!important;height:40px!important}[data-testid="entrypoint"] .text-base-body{font-size:14px!important}}';
        style.textContent+="@media(max-width:750px){[data-testid=\"entrypoint\"]>button{display:none!important}[data-testid=\"entrypoint\"]>[role=\"button\"]{width:44px!important;height:44px!important;min-width:44px!important;max-width:44px!important;box-sizing:border-box!important}[data-testid=\"entrypoint\"]>[role=\"button\"]>div:first-child{padding:4px!important;gap:0!important;box-sizing:border-box!important}[data-testid=\"entrypoint\"] .size-16{width:32px!important;height:32px!important}[data-testid=\"entrypoint\"] .text-base-body,[data-testid=\"entrypoint\"] button[aria-label=\"Dismiss\"]{display:none!important}[data-testid=\"entrypoint\"] .entrypoint-beam-dot{display:none!important}}";
        root.append(style);
      }
      if(root&&root!==observedRoot){new MutationObserver(schedule).observe(root,{childList:true,subtree:true});observedRoot=root}
      const launcher=root?.querySelector('[data-testid="entrypoint"]');
      if(mobile.matches&&launcher){
        const rect=(launcher.querySelector('[role="button"]')||launcher).getBoundingClientRect();
        const usable=rect.width>0&&rect.height>0;
        const compact=usable&&rect.right+12>innerWidth-12-116;
        button.classList.toggle('ew-back-to-top--compact',compact);
        if(usable)setProperty(button,'--ew-widget-height',Math.max(48,rect.height)+'px');
      }else{
        button.classList.remove('ew-back-to-top--compact');
        button.style.removeProperty('--ew-widget-height');
      }
    };
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    window.visualViewport?.addEventListener('resize',schedule);
    document.addEventListener('ew:sticky-cart-change',schedule);
    new MutationObserver(schedule).observe(document.body,{childList:true});
    let attempts=0;
    const ready=setInterval(()=>{schedule();if(observedRoot||++attempts>=40)clearInterval(ready)},500);
    button.addEventListener('click',()=>{
      const target=document.querySelector('main');
      if(target){if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');target.focus({preventScroll:true})}
      window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    });
    update();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
